// Copyright 2021 Sorama B.V.

export class FileNameExtensions {
    public static getName(filePath: string): string {
        return filePath.match(/[^/]*$/)[0].replace(/.[^/.]+$/, "");
    }

    public static getExtension(filePath: string): string {
        return filePath.match(/[^/.]+$/)[0];
    }
}
